import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  container: {
    maxWidth:'100%',
    // width:'100%',
    // height: 200,
    marginBottom: 20,
    // paddingRight: '10%',
    // marginRight: '2%',
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: 'red',
  },
  imageContainer: {
    // paddingRight: '4%',
    // width: '96%',
    // backgroundColor: 'green',
  },
  image: {
    // aspectRatio: 1000 / 720,
    aspectRatio: 1440 / 1080,
    // width: '96%',
  },
  textOverlay: {
    position: 'absolute',
    left:0,
    bottom: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'flex-end',
    padding: 10,
    // backgroundColor: 'rgba(0,0,0,0.5)',
  },
  nameAmount: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  name: {
    marginRight: 10,
    marginTop: 0,
    marginBottom: 5,
  },
  amount: {
    marginRight: 10,
    marginTop: 0,
    marginBottom: 5,
    marginLeft: 'auto',
  },
  location: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  }
});

export default styles;